module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('h1', {
    staticClass: "article-title"
  }, [_vm._v("The Technology")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', [_vm._v("Contents")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("\n          As mentioned in "), _c('a', {
    attrs: {
      "href": "/about/story#p2"
    }
  }, [_vm._v("the story")]), _vm._v(", the data is being downloaded from a \n          "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/resource/v7k9-7dn4.json"
    }
  }, [_vm._v("json feed provided by data.seattle.gov")]), _vm._v(". There is a job scheduled that will download collisions \n          from the past 150 days, check for changes, then update existing collisions and create new ones. I'd like to write a blog post sometime that talks more \n          about the import process, how I transformed the data, and challenges I ran into. This is on my "), _c('router-link', {
    attrs: {
      "to": {
        name: 'toDo'
      }
    }
  }, [_vm._v("to do list")]), _vm._v(".\n        ")], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#front"
    }
  }, [_vm._v("Front end")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#back"
    }
  }, [_vm._v("Back end")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#vendors"
    }
  }, [_vm._v("Vendors")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "front"
    }
  }), _vm._v("Front end")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The front end is built with "), _c('a', {
    attrs: {
      "href": "//vuejs.org"
    }
  }, [_vm._v("VueJs")]), _vm._v(". If you are new to VueJS, there is "), _c('a', {
    attrs: {
      "href": "//vuecasts.com"
    }
  }, [_vm._v("video tutorial series\n          for FREE DOLLARS!")]), _vm._v(" Put together by "), _c('a', {
    attrs: {
      "href": "//twitter.com/jeffrey_way"
    }
  }, [_vm._v("Jeffery Way")]), _vm._v(" at "), _c('a', {
    attrs: {
      "href": "//laracasts.com"
    }
  }, [_vm._v("Laracasts")]), _vm._v(". \n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//github.com/vuejs/vue-cli"
    }
  }, [_vm._v("Vue-CLI")]), _vm._v(" to scaffold out WebPack 2 and my directory structure")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//webpack.js.org"
    }
  }, [_vm._v("WebPack 2")]), _vm._v(" for module bundling & build process")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//router.vuejs.org/en"
    }
  }, [_vm._v("Vue-Router")]), _vm._v(" for URL routing")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//vuex.vuejs.org/en/intro.html"
    }
  }, [_vm._v("Vuex")]), _vm._v(" for state management")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/vuejs/vuex-router-sync"
    }
  }, [_vm._v("Vuex router sync")]), _vm._v(" for keeping router in sync with storage.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.chartjs.org"
    }
  }, [_vm._v("ChartJS")]), _vm._v(" for pie, bar, & line charts")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//leafletjs.com"
    }
  }, [_vm._v("Leaflet")]), _vm._v(" for maps")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/Leaflet/Leaflet.markercluster"
    }
  }, [_vm._v("Leaflet.markercluster")]), _vm._v(" for clustering points on a map")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/Leaflet/Leaflet.heat"
    }
  }, [_vm._v("Leaflet.heat")]), _vm._v(" for heatmap effect on maps")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//momentjs.com"
    }
  }, [_vm._v("MomentJS")]), _vm._v(" for date formatting and manipulation")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/dbushell/Pikaday"
    }
  }, [_vm._v("Pikaday")]), _vm._v(" for date pickers")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//meyerweb.com/eric/tools/css/reset/"
    }
  }, [_vm._v("Eric Meyer's CSS Reset")]), _vm._v(" for css reset")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//lodash.com"
    }
  }, [_vm._v("Lodash")]), _vm._v(" for utility")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/mzabriskie/axios"
    }
  }, [_vm._v("Axios")]), _vm._v(" for async promise based API calls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "back"
    }
  }), _vm._v("Back end")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          I'm a PHP developer so I built the backend in "), _c('a', {
    attrs: {
      "href": "//www.php.net"
    }
  }, [_vm._v("PHP")]), _vm._v(". I like the "), _c('a', {
    attrs: {
      "href": "//laravel.com"
    }
  }, [_vm._v("Laravel PHP framework")]), _vm._v(", so I used that.\n          If you're new to Laravel, guess what? There is ANOTHER "), _c('a', {
    attrs: {
      "href": "//laravelfromscratch.com"
    }
  }, [_vm._v("video tutorial series to help you get started with Laravel")]), _vm._v(". Also\n          for FREE DOLLARS by "), _c('a', {
    attrs: {
      "href": "//twitter.com/jeffery_way"
    }
  }, [_vm._v("Jeffery Way")]), _vm._v(". Whatta guy! If you're looking for a book on Laravel, well lucky you.\n          "), _c('a', {
    attrs: {
      "href": "//mattstauffer.co"
    }
  }, [_vm._v("Matt Stauffer")]), _vm._v(" recently published his book "), _c('a', {
    attrs: {
      "href": "//laravelupandrunning.com"
    }
  }, [_vm._v("Laravel Up & Running")]), _vm._v(". I bought it. It's good.\n          I'm using "), _c('a', {
    attrs: {
      "href": "//www.mysql.com"
    }
  }, [_vm._v("MySQL")]), _vm._v(" for my database.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "back"
    }
  }), _vm._v("Vendors")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//www.webfaction.com/?aid=45281"
    }
  }, [_vm._v("WebFaction")]), _vm._v(" for hosting the front end VueJS app")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.digitalocean.com"
    }
  }, [_vm._v("Digital Ocean")]), _vm._v(" for hosting the back end Laravel app serving up the API.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//forge.laravel.com"
    }
  }, [_vm._v("Laravel Forge")]), _vm._v(" for server provisioning")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//envoyer.io"
    }
  }, [_vm._v("Envoyer.io")]), _vm._v(" for deployment")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.cloudflare.com"
    }
  }, [_vm._v("CloudFlare")]), _vm._v(" for DNS")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.bitbucket.org"
    }
  }, [_vm._v("BitBucket")]), _vm._v(" for Git repository")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//gandi.net"
    }
  }, [_vm._v("Gandi")]), _vm._v(" for domain registration")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f054b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about/Technology.vue
// module id = 431
// module chunks = 1